import { SIDEBAR_ITEMS, SIDEBAR_OPEN, MOBILEMENU_EXPANDED, USERMENU_LAYOUT, ACTIVE_TASKID, DRAWER_OPEN, } from './types';
export var setSidebarItems = function (paylaod) { return ({
    type: SIDEBAR_ITEMS,
    paylaod: paylaod,
}); };
export var setSidebarlistOpen = function (paylaod) { return ({
    type: SIDEBAR_OPEN,
    paylaod: paylaod,
}); };
export var setMobileMenuExpanded = function (paylaod) { return ({
    type: MOBILEMENU_EXPANDED,
    paylaod: paylaod,
}); };
export var setUserMenuLayouts = function (paylaod) { return ({
    type: USERMENU_LAYOUT,
    paylaod: paylaod,
}); };
export var setActiveTaskId = function (paylaod) { return ({
    type: ACTIVE_TASKID,
    paylaod: paylaod,
}); };
export var setDrawerOpen = function (paylaod) { return ({
    type: DRAWER_OPEN,
    paylaod: paylaod,
}); };
